<header class="header">
  <a class="logo" target="_blank" rel="noopener" href="http://cbml.ds.unipi.gr/"
     title="Computational Biomedicine Lab"></a>
  <input class="menu-btn" type="checkbox" id="menu-btn"/>
  <label class="menu-icon" for="menu-btn"><span class="navicon"></span></label>
  <ul class="menu">
    <li><a style="color: white" [routerLink]="['local']">LOCALLY</a></li>
    <li><a style="color: white" [routerLink]="['call-api']">API</a></li>
    <li>
      <a target="_blank" rel="noopener" href="https://mediapipe.dev/" title="mediapipe">
        <img width="16" alt="Media pipe logo" src="assets/images/mediaPipe.png"/>
      </a>
    </li>
  </ul>
</header>
<div class="content" style="padding-top: 10px" role="main">
  <router-outlet></router-outlet>
</div>
<footer style="position: relative;display: flex;justify-content: center">
    Developed by <a href="https://galliakis.com" style="padding-left: 0.2rem">Michael Galliakis</a>
</footer>


